import { fetchWithCache, getCachedData } from "../services/apiService";

export const propertiesRecent = async ({ setPropertiesRecentt }) => {
  // Show cached data immediately if available
  const cached = getCachedData("/api/property/recent", {});
  if (cached) {
    setPropertiesRecentt(cached);
  }

  try {
    const data = await fetchWithCache(
      "/api/property/recent",
      {
        method: "GET",
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setPropertiesRecentt(Array.isArray(data) ? data : []);
  } catch (error) {
    if (!cached) {
      setPropertiesRecentt([]);
    }
  }
};
